import { HttpInterceptorFn, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  return next(addHeaders(req)).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error(`HTTP Error: ${req.method} ${req.url}`, error);
      return throwError(() => error);
    })
  );
};

function addHeaders(request: HttpRequest<unknown>): HttpRequest<unknown> {
  const isFormData = request.body instanceof FormData;
  const isExternalGate = request.url.includes('external-gate-service');
  const isChannelIndication = request.url.includes('/user-indications/channel');

  // Channel indication: match Postman headers only
  // Accept: application/json | Content-Type: application/json | X-Api-Key
  if (isChannelIndication) {
    return request.clone({
      setHeaders: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-API-Key': environment.apiKey,
      },
    });
  }

  const headers: Record<string, string> = {
    Accept: 'application/json, text/plain, */*',
    'Accept-Language': 'pt-BR,pt;q=0.9',
    'X-API-Key': isExternalGate ? environment.apiKeyExternalGate : environment.apiKey,
  };

  if (!isFormData) {
    headers['Content-Type'] = 'application/json';
  }

  return request.clone({
    setHeaders: headers,
  });
}
